import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  AUTH_STATUSES,
  authBootstrapPendingSelector,
  authStatusSelector,
  bootstrapAuth
} from '../slices/authSlice';

export const AuthController = ({ children, fallback = null }) => {
  const dispatch = useDispatch();
  const status = useSelector(authStatusSelector);
  const bootstrapPending = useSelector(authBootstrapPendingSelector);

  useEffect(() => {
    if (status === AUTH_STATUSES.CHECKING && !bootstrapPending) {
      dispatch(bootstrapAuth());
    }
  }, [bootstrapPending, dispatch, status]);

  if (status === AUTH_STATUSES.CHECKING) {
    return fallback;
  }

  return children;
};
